import baseService from './baseService';

export const getCarReportPDF = async (vin, paymentDetails) => {
  try {
    const response = await baseService.post(`clearvin/get-car-report-pdf?vin=${vin}`, paymentDetails);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCarReportPreview = async (vin) => {
  try {
    const response = await baseService.get(`clearvin/get-car-preview?vin=${vin}`);
    return response;
  } catch (error) {
    throw error;
  }
};
